import { Reveal } from "./Reveal";
import { IMAGES } from "../lib/data";

export const Experience = () => (
  <section id="experience" data-testid="experience-section" className="relative py-20 md:py-32 border-t border-white/5">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <div className="lg:col-span-7">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5 md:mb-6">What We Do</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black uppercase tracking-tight text-white text-3xl sm:text-4xl md:text-6xl leading-[0.95]">
            Premium beverage
            <span className="block text-[#D4AF37]">activations at scale.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 md:mt-8 max-w-xl text-base md:text-lg text-white/65 font-light leading-relaxed">
            Good Shot designs, builds and operates luxury beverage activations capable of serving
            hundreds or thousands of guests. Our proprietary systems combine handcrafted quality with
            the speed, consistency and presentation of a world-class hospitality operation.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-5 max-w-xl text-base md:text-lg text-white/65 font-light leading-relaxed">
            The Espresso Martini Bar is our signature experience — but our modular systems let us execute
            virtually any premium craft cocktail program, deployed to the same standard nationwide.
          </p>
        </Reveal>
      </div>

      <div className="lg:col-span-5">
        <Reveal delay={0.2}>
          <div className="relative group overflow-hidden">
            <img
              src={IMAGES.pour}
              alt="Espresso martini being poured"
              className="w-full h-[340px] sm:h-[440px] md:h-[560px] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-[#D4AF37]/20" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
